import { render, staticRenderFns } from "./EquipmentAssignment.vue?vue&type=template&id=3279b0b8&scoped=true"
import script from "./EquipmentAssignment.vue?vue&type=script&lang=js"
export * from "./EquipmentAssignment.vue?vue&type=script&lang=js"
import style0 from "./EquipmentAssignment.vue?vue&type=style&index=0&id=3279b0b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279b0b8",
  null
  
)

export default component.exports